import { render } from "./OverviewPage.vue?vue&type=template&id=e8a7bb60&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=e8a7bb60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a7bb60"]])

export default __exports__